import moment from 'moment';

const initState = {
  subordinatesTimesheets: []
}

const subordinatesReducer = (state = initState, action) => {
  switch (action.type) {
    case 'CHANGE_DATE_OBJECT_ADD':
      return {
        ...state, 
        dateObject: moment(state.dateObject).add(1, "month"),  
        currentMonth: action.month, 
      }
    case 'CHANGE_DATE_OBJECT_SUBTRACT':
      return {
        ...state, 
        dateObject: moment(state.dateObject).subtract(1, "month"),  
        currentMonth: action.month, 
      }
    case 'ADD_SUBORDINATES_TIME_ENTRIES':
      return {
        ...state,
        subordinatesTimesheets: [...state.subordinatesTimesheets, action.timeEntry]
      }
    case 'RESET_SUBORDINATES_TIME_ENTRIES':
      return {
        ...state, 
        subordinatesTimesheets: [] 
      }
    default: 
      return state;
  }
}

export default subordinatesReducer